import { defaultHttpClient } from '../../httpClient';
import { atomicRendererDataConverter } from '../getScreens/atomicRendererDataConverter';
import type { ScreensReadResponse } from '../getScreens/types';
import type { IScreensComponent } from '../getScreens/types';
import type { IScreensLogging } from '../../types';

export interface InjectResult {
  components: IScreensComponent[];
  /** 서버가 내려주는 VIEW 이벤트명 (예: "VIEW_DISPLAY_CLICK_REVIEW_COORDINATION") */
  eventName?: string;
  /** VIEW 이벤트 로깅 데이터 */
  eventLogging?: IScreensLogging;
}

/**
 * inject API 호출 - on_return 액션에 포함된 URL로 컴포넌트 데이터 요청
 * iOS MetaFeedProvider.fetchInjectComponents()와 동일
 *
 * 응답 최상위의 event_name/event_logging도 보존
 * (iOS MetaFeedPageModel.eventName/eventLogging 대응)
 */
export const getInjectComponents = (
  url: string,
): Promise<InjectResult> => {
  return defaultHttpClient
    .request<ScreensReadResponse>({ method: 'GET', url: `/api/v2/${url}` })
    .then(result => {
      const data = result.data;
      if (!data.components) {
        return { components: [] };
      }
      return {
        components: atomicRendererDataConverter(data).components,
        eventName: data.event_name,
        eventLogging: data.event_logging,
      };
    });
};
